module.exports = __webpack_public_path__ + "img/btn-lottery.5f2e3716.png";